import { css } from "styled-components";
import { Carousel, CarouselSlide, CarouselViewport, CarouselSlides, CarouselProgressBar, CarouselControls, } from "../../../../components/Carousel";
import { Icon } from "../../../../components/Icon";
import { CTA } from "../../../../components/CTA";
import { BladeContent } from "../../../../components/BladeContent";
export const riotProductSkin = (chroma, paletteTokens) => css `
  & {
    padding: ${chroma.spacers.bladeEdge.top} 0 ${chroma.spacers.bladeEdge.bottom};
  }

  ${BladeContent} {
    ${chroma.mediaQueries.tabletDown} {
      margin: 0;
    }
  }

  ${CarouselViewport} {
    ${CarouselSlides} {
      display: flex;
      gap: ${chroma.spacers.variable.m};
    }
  }

  .backdrop {
    width: 100%;
    height: 100%;
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    overflow: hidden;
  }

  .header {
    position: relative;
    display: flex;
    flex-direction: row;
    margin-bottom: ${chroma.spacers.variable.l};
    gap: ${chroma.spacers.variable.m};
    justify-content: space-between;

    h2 {
      ${chroma.typography.display6};
    }

    ${CTA} {
      ${chroma.typography.body3}
      align-self: center;
      ${Icon} {
        background-color: ${paletteTokens.accents1};
      }
    }
  }

  ${Carousel} {
    &[data-state-all-slides-visible="true"] {
      ${CarouselControls} {
        display: none;
      }
      ${CarouselSlides} {
        justify-content: center;
      }
      ${CarouselSlide} {
        width: calc(((100% - (var(--carousel-gap) * var(--carousel-gap-count))) / (1 * var(--carousel-n-up))));
      }
    }
  }

  ${CarouselSlide} {
    --carousel-n-up: 3;
    ${chroma.mediaQueries.tabletDown} {
      --carousel-n-up: 2;
    }
    ${chroma.mediaQueries.mobileDown} {
      --carousel-n-up: 1;
    }

    --carousel-gap: ${chroma.spacers.variable.m};
    --carousel-gap-count: calc(var(--carousel-n-up) - 1);

    min-width: calc(((100% - (var(--carousel-gap) * var(--carousel-gap-count))) / (1 * var(--carousel-n-up))));
  }

  ${CarouselControls} {
    position: relative;
    margin-top: ${chroma.spacers.variable.s};
    gap: ${chroma.spacers.constant.s};
    display: flex;
    justify-content: flex-end;

    .trigger-wrapper {
      display: flex;
      gap: ${chroma.spacers.constant.xs};
      align-self: flex-end;
    }

    ${CarouselProgressBar} {
      width: 100%;
      padding-right: 0;

      .indicator {
        transition: width 0.7s ease-out;
        background-color: ${paletteTokens.accents1};
        height: 4px;
      }

      .rail {
        margin-top: 0;
        width: 100%;
        background-color: ${paletteTokens.keyline};
      }

      flex-grow: 1;
      align-self: center;
      ${chroma.mediaQueries.mobileDown} {
        height: 12px;
        width: 100%;
      }
    }

    .prev,
    .next {
      ${Icon} {
        background-color: ${paletteTokens.accents1};
      }

      &:disabled {
        ${Icon} {
          background-color: ${paletteTokens.keyline};
        }
      }
    }
  }
`;
//# sourceMappingURL=index.js.map